import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { ROUTES } from '@/navigation/constants'
import { Footer } from '@/shared/ui/Footer'

export const NotFoundPage = () => {
    const { t } = useTranslation()

    return (
        <div className='flex min-h-screen flex-col bg-background text-foreground'>
            <Helmet>
                <meta name='robots' content='noindex' />
            </Helmet>
            <main className='flex flex-1 flex-col items-center justify-center gap-8 px-4 py-16'>
                <div className='mx-auto flex max-w-lg flex-col items-center gap-4 text-center'>
                    <h1 className='text-3xl font-semibold md:text-4xl'>{t('notFound.title')}</h1>
                    <p className='text-base text-muted-foreground'>{t('notFound.description')}</p>
                </div>
                <Button asChild size='lg'>
                    <Link to={ROUTES.home}>{t('notFound.backToHome')}</Link>
                </Button>
            </main>

            <Footer landingPage='not-found' />
        </div>
    )
}
